export default __webpack_public_path__ + "static/Contact-us-animation-white-8c3b9bc9a61def5fb6a79a527bee6e89.gif";